module.exports = __webpack_public_path__ + "static/media/orange.2efd25ab.svg";